<template>
  <Card>
    <h1 slot="Title">Application of Funds: 202011D20_</h1>
    <div slot="MainContent">
      <p>
        <b>Appropriation Symbol</b>: 2020
      </p>
      <p>
        <b>Years of Availability</b>: 1
      </p>
      <p><b>Examples</b>:</p>
      <div class="ThreeWrapper">
        <ul>
          <li class="OneThird">
            2010: Military personnel, Army
          </li>
          <li class="OneThird">
            1 year
          </li>

          <li class="OneThird">
            2020: Operations and Maintenance, Army (OMA)
          </li>
          <li class="OneThird">
            1 year
          </li>

          <li class="OneThird">
            2035: Other procurement, Army
          </li>
          <li class="OneThird">
            3 Years
          </li>

          <li class="OneThird">
            2040: Research, Development, Test and Evaluation
          </li>
          <li class="OneThird">
            2 Years
          </li>
          
          <li class="OneThird">
            2050: Military Construction	
          </li>
          <li class="OneThird">
            5 Years
          </li>

          <li class="OneThird">
            2091: Afghanistan Security Forces Funds
          </li>
          <li class="OneThird">
            2 Years
          </li>
        </ul>
        <br><br>
        <p> <b><u>202011D20</u></b>  A76VV 131096QLOG 6100.2617 WBS, Internal Order or Cost Center 1000000067 021001</p>
      </div>
    </div>
    <div slot="Notes">
        <p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="font-size: 16px; font-family: Calibri; color: rgb(255, 255, 255); font-weight: bold;">Application of Funds</span></p>
        <p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="color: rgb(255, 255, 255);"><span style="font-size: 16px; font-family: Calibri; font-weight: bold;">Refer students to Summary Sheet, Identify GFEBS Master Data page #5, and Army Management Structure (Federated ERPs) Guide, Chapter 4, par 4.2.1</span></span></p>
        <p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="color: rgb(255, 255, 255);"><span style="font-size: 16px; font-family: Calibri;">b.&nbsp;</span><span style="font-size: 16px; font-family: Arial; font-weight: bold;">Application of Funds&nbsp;</span><span style="font-size: 16px; font-family: Calibri; font-weight: bold;">(202011D**(_).&nbsp;</span><span style="font-size: 16px; font-family: Calibri;">The Application of funds normally consists of the first 10 characters in the line of accounting. &nbsp;There are six parts: Main Account Code (Appropriation Symbol), (characters 1-4), Years of Availability, (character 5), &nbsp;Supplemental Appropriation ID,(character 6), &nbsp;Fund Type Designator(character 7), Fiscal Year of Issue,(character 8-9) and a Blank Space, (character 10). The Fund Master Data Element record is a separate and distinct fiscal/accounting object used to budget and control costs and to identify the source and use of funding.</span></span></p>
        <p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="color: rgb(255, 255, 255);"><span style="font-size: 16px; font-family: Calibri; font-weight: bold;">Refer students to Army Management Structure (Federated ERPs) Guide &gt;AO-2020 (This is used for AO-0720 thru AO-2097)</span></span></p>
        <p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="color: rgb(255, 255, 255);"><span style="font-size: 16px; font-family: Calibri; font-weight: bold;">Note: Army Management Structure (Federated ERPs) Guide &gt;AO-2020&nbsp;</span><span style="font-size: 16px; font-family: Calibri; font-weight: bold; font-style: italic;">and Guide chapter 4.2.1, positions 1-4</span></span></p>
        <p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="color: rgb(255, 255, 255);"><span style="font-size: 16px; font-family: Calibri; font-weight: bold; font-style: normal;">The first</span><span style="font-size: 16px; font-family: Calibri; font-weight: bold; font-style: normal; vertical-align: baseline;">&nbsp;two parts of&nbsp;</span><span style="font-size: 16px; font-family: Calibri; font-weight: bold;">Application of Funds&nbsp;</span><span style="font-size: 16px; font-family: Calibri; font-weight: bold; font-style: normal; vertical-align: baseline;">consist of</span><span style="font-size: 16px; font-family: Calibri; font-weight: bold;">&nbsp;</span><span style="font-size: 16px; font-family: Calibri; font-weight: bold; font-style: normal; vertical-align: baseline;">the&nbsp;</span><span style="font-size: 16px; font-family: Calibri; font-weight: bold; font-style: normal;">Appropriation Symbol and the&nbsp;Year(s) of Availability (in bold above).</span></span></p>
        <p style="line-height:normal;margin-top:4.32pt;margin-bottom:0pt;margin-left:0in;margin-right:0in;text-indent:0in;text-align:left;vertical-align:baseline;"><span style="color: rgb(255, 255, 255);"><span style="font-size: 16px; font-family: Calibri;">(1)&nbsp;</span><span style="font-size: 16px; font-family: Arial; font-weight: bold;">Basic Symbol or Appropriation Symbol&nbsp;</span><span style="font-size: 16px; font-family: Calibri; font-weight: bold;">(</span><span style="font-size: 16px; font-family: Arial; font-weight: bold;">2020&ndash;Operation and Maintenance, Army</span><span style="font-size: 16px; font-family: Calibri; font-weight: bold;">).</span><span style="font-size: 16px; font-family: Calibri;">&nbsp; &nbsp;The second part of the Application of Funds is the Appropriation Symbol. The Appropriation Symbol is an authorization, by an Act of Congress, to make payments out of the Treasury for specified purposes. &nbsp;These four digits of the Application of funds indicate the Treasury Fund Group to which the line of accounting applies. &nbsp;The digits identify the type of funds or major purpose of the appropriation. &nbsp; 2020 &nbsp;Operation and Maintenance, Army (OMA) &nbsp;</span></span></p>
        <p style="line-height:normal;margin-top:4.32pt;margin-bottom:0pt;margin-left:0in;margin-right:0in;text-indent:0in;text-align:left;vertical-align:baseline;"><span style="color: rgb(255, 255, 255);"><span style="font-size: 16px; font-family: Calibri; font-weight: bold;">Instructor Note: Army Management Structure (Federated ERPs) Guide,&nbsp;</span><span style="font-size: 16px; font-family: Calibri; font-weight: bold; font-style: italic;">chapter 4.2.1, position</span><span style="font-size: 16px; font-family: Calibri; font-weight: bold; font-style: italic; vertical-align: baseline;">&nbsp;5</span></span></p>
        <p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="color: rgb(255, 255, 255);"><span style="font-size: 16px; font-family: Calibri; font-weight: bold;">&nbsp;</span><span style="font-size: 16px; font-family: Calibri;">(2)</span><span style="font-size: 16px; font-family: Calibri; font-weight: bold;">&nbsp;Year(s) of Availability (1). &nbsp;</span><span style="font-size: 16px; font-family: Calibri;">The third part of the Application of Funds is the Year of availability. The Year(s) of Availability code is a one-digit code that identifies the period(s) or FY(s) in which Congress made the funds available for obligation.&nbsp;</span></span></p>
        <p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="color: rgb(255, 255, 255);"><span style="font-size: 16px; font-family: Calibri; font-weight: bold;">Explain to the students that the&nbsp;</span><u><span style="font-size: 16px; font-family: Calibri; font-weight: bold;">1</span></u><span style="font-size: 16px; font-family: Calibri; font-weight: bold;">&nbsp;can also be an&nbsp;</span><u><span style="font-size: 16px; font-family: Calibri; font-weight: bold;">X</span></u><span style="font-size: 16px; font-family: Calibri; font-weight: bold;">&nbsp;for no years.&nbsp;</span></span></p>
      </div>
  </Card>
</template>

<style scoped>
.ThreeWrapper {
  width: 100%;
  max-width: 1200px;
  margin-bottom: 32px;
}

ul {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  padding-left: 0;
}

ul > li {
  width: 50%;
  list-style: none;
  margin-bottom: 0;
}

ul > li:nth-child(4n), ul > li:nth-child(4n-1) {
  background-color: rgba(255, 255, 255, .2);
}

ul > li:nth-child(3), ul > li:nth-child(4) {
  font-weight: 500;
  border-bottom: 1px solid white;
}

ul > li > b {
  font-weight: 700;
}

</style>

<script>
import Card from '../../../components/Card.vue';

export default {

  components: {
    Card
  },
  name: 'StatesofanAppropriationExamples',
  
  data() {
    return {
    }
  }
  
}
</script>